export default class AObject {
    constructor () {}

    draw (p5) {}
}



// WEBPACK FOOTER //
// ./webpack/js/abstracts/AObject.js